/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { UtilityService } from '../Utility.Service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private utilService: UtilityService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.info("IN INTERCEPTOR: ", request.url);
    return next
      .handle(request)
      .pipe(tap({
        error: (e) => {
          if (e instanceof HttpErrorResponse) {
            this.handleError(e);
          }
        }
      }));
  }

  handleError(theErrorResponse: HttpErrorResponse) {
    let eventStatus = theErrorResponse.status;
    let handleError = false;
    if (eventStatus === 401) {
      handleError = true;
    }
    else {
      let serverError = this.utilService.errorService.getQsmServerError(theErrorResponse);
      if (serverError && serverError.errorId) {
        handleError = true;
      }
    }
    if (handleError) {
      this.utilService.errorService.ErrorRedirect(theErrorResponse);
    }
  }
}
